import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, publishedRenderUrl } from "../lib/api";
import { LogoMark } from "../components/brand/Logo";

export default function PublishedApp({ slugOverride }) {
  const params = useParams();
  const slug = slugOverride || params.slug;
  const [meta, setMeta] = useState(undefined);

  useEffect(() => {
    api.publishedMeta(slug).then((m) => { setMeta(m); document.title = m.name; }).catch(() => setMeta(null));
  }, [slug]);

  if (meta === undefined) return <div className="h-screen flex items-center justify-center bg-[#F5F8FC]"><Loader2 className="animate-spin text-emerald-600" /></div>;
  if (meta === null) {
    return (
      <div className="h-screen flex flex-col items-center justify-center gap-4 bg-[#F5F8FC] text-center px-6" data-testid="published-not-found">
        <LogoMark size={40} />
        <h1 className="text-2xl font-bold text-slate-900">This app isn't live</h1>
        <p className="text-slate-500 text-sm">It may have been unpublished, or the address is wrong.</p>
        <Link to="/" className="text-emerald-600 text-sm hover:underline">Build your own with Ishukart</Link>
      </div>
    );
  }
  return (
    <div className="fixed inset-0 bg-white" data-testid="published-app">
      <iframe title={meta.name} src={publishedRenderUrl(slug)} className="w-full h-full border-0" data-testid="published-iframe"
        sandbox="allow-scripts allow-forms allow-popups allow-modals allow-downloads allow-popups-to-escape-sandbox" />
      {!slugOverride && (
        <a href="/" target="_blank" rel="noreferrer" data-testid="built-with-badge"
          className="fixed bottom-3 right-3 flex items-center gap-1.5 h-7 px-2.5 rounded-full bg-white/90 backdrop-blur border border-slate-300 text-[11px] text-slate-600 hover:text-slate-900 shadow-lg">
          <LogoMark size={16} /> Built with Ishukart
        </a>
      )}
    </div>
  );
}
